<template>
  <div class="container">
    <form class="form-horizontal" v-on:submit="save">
      <div class="columns">
        <div class="col-3 col-md-12">
          <label class="form-label">{{question.text}}</label>
        </div>
        <div class="col-4 col-md-12">
          <div class="input-group">
            <input class="form-input" type="text" v-model="answer.atxt" @blur="save"/>
          </div>
        </div>
      </div>
    </form>

    <div class="columns">
      <div class="col-7 col-md-10">
        <div v-if="question.helptext" class="tooltipz" v-html="question.helptext"></div>
      </div>
    </div>
  </div>
</template>

<script>
import baseQ from '@/components/questions/base'
export default {
  name: 'textQ',
  extends: baseQ
}
</script>



// WEBPACK FOOTER //
// text.vue?54612000